import type { RouteObject } from 'react-router';

import { AuthLayout } from './auth-layout';
import { RedirectIfSignedIn } from './guards';
import {
  ForgotPasswordPage,
  ForgotPasswordSentPage,
  ResetPasswordPage,
} from './password-reset-pages';
import { SignInPage } from './sign-in-page';
import { ConfirmEmailPage, SignUpPage } from './sign-up-page';
import { SsoCallbackPage } from './sso-callback-page';
import { ProviderErrorPage, ResetCodeExpiredPage } from './status-pages';

/**
 * The Auth B screens (Figma ↳ Auth Screens, "B · Mark field"), outside the app
 * shell, wired to Clerk. Two-factor screens (two-factor-page.tsx,
 * two-factor-setup-page.tsx) stay unrouted until MFA is turned on in Clerk.
 */
export const authRoutes: RouteObject[] = [
  {
    element: (
      <RedirectIfSignedIn>
        <AuthLayout />
      </RedirectIfSignedIn>
    ),
    children: [
      { path: 'sign-in', element: <SignInPage /> },
      { path: 'sign-in/provider-error', element: <ProviderErrorPage /> },
      { path: 'sign-up', element: <SignUpPage /> },
      { path: 'sign-up/confirm-email', element: <ConfirmEmailPage /> },
      { path: 'forgot-password', element: <ForgotPasswordPage /> },
      { path: 'forgot-password/sent', element: <ForgotPasswordSentPage /> },
      { path: 'reset-password', element: <ResetPasswordPage /> },
      { path: 'reset-password/expired', element: <ResetCodeExpiredPage /> },
    ],
  },
  // Google/GitHub land here; not behind RedirectIfSignedIn, since the session
  // is created on this page.
  { path: 'sso-callback', element: <SsoCallbackPage /> },
];
